import { createTheme } from '@material-ui/core/styles';
import { CustomThemeOptions } from './types';
import COLOURS from '../../constants/colours';

const lightTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: COLOURS.purple,
      dark: COLOURS.dark,
      contrastText: COLOURS.light,
    },
    success: {
      main: COLOURS.successGreen,
    },
    error: {
      main: COLOURS.errorRed,
    },
    background: {
      default: '#f5f6fa',
      paper: '#fff',
      elevation1: '#fff',
      elevation2: '#fff',
      navigation: '#fff',
      specialCard: '#20154e',
    },
    text: {
      primary: COLOURS.dark,
      secondary: COLOURS.purple,
      navigation: COLOURS.mediumGrey,
      tooltip: COLOURS.mediumGrey,
      logo: '#20154e',
      description: COLOURS.dark,
    },
    grey: {
      400: COLOURS.lightGrey,
      600: COLOURS.mediumGrey,
      700: COLOURS.middleGrey,
    },
  },
  typography: {
    fontFamily: "'Mulish', sans-serif",
    subtitle1: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '18px',
      lineHeight: '24px',
    },
    subtitle2: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '20px',
      lineHeight: '32px',
    },
    h1: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '36px',
      lineHeight: '45px',
      letterSpacing: '-1px',
    },
    h2: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '20px',
      lineHeight: '32px',
    },
    h3: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '24px',
      lineHeight: '30px',
      letterSpacing: '-1px',
    },
    h6: {
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '20px',
    },
    body1: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '24px',
    },
    body2: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '12px',
      lineHeight: '16px',
    },
  },
} as CustomThemeOptions);

export default lightTheme;
